import React from "react";
import PropTypes from "prop-types";
import Header from "./Header";

export default function Question(props) {
  const { dictionary, question, click, progress } = props;

  const options = question.data.options.map((option, index) => {
    return (
      <li
        key={`option_${question.current}_${index + 1}`}
        className="option-list__item"
        onClick={() => click(index)}
      >
        {dictionary[`option_${question.current}_${index + 1}`]}
      </li>
    );
  });

  return (
    <div className="own-it__question">
      <Header current={question.current} all={question.all} />
      <div className="question__top">
        <div className="question__top-left">
          <p className="question__text">
            {dictionary[`question_${question.current}`]}
          </p>
          {progress}
        </div>
        <div className="question__top-right">
          <div className="question__img">
            <img src={question.data.img} alt="" />
          </div>
        </div>
      </div>
      <div className="question__bottom">
        <ul className="option-list">{options}</ul>
      </div>
    </div>
  );
}

Question.propTypes = {
  dictionary: PropTypes.object,
  question: PropTypes.object,
  click: PropTypes.func
};
